var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"max-width":"420px","height":"250px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }